import api from "api";

export const getIncenctivesWeightageAndTargetDashboard = (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `v1/incentive/weightageAndTarget?${queryString}`;
  return api.get(url);
};

export const getIncenctivesWeightageAndTargetDashboardFilterData = () => {
  return api.get("v1/incentive/weightageAndTargetFilters");
};

export function editWeightageAndTargetDBdata(payload) {
  return api.put(`v1/incentive/weightageAndTarget`, payload);
}
